// import './axios.interceptor.js';
import axios from "axios";
import api_url from "./api_url";

export default class UserService {
  constructor(base_url) {
    if (base_url) {
      this.base_url = base_url;
    } else {
      this.base_url = api_url;
    }
  }

  async getClient() {
    const response = await fetch("./clients.json");
    const file = await response.json();
    return file;
  }

  async login(loginData) {
    const response = await axios.post(
      `${this.base_url}/v1/auth/login`,
      loginData
    );
    return response;
  }

  async changePassword(loginData) {
    const response = await axios.post(
      `${this.base_url}/v1/auth/change-password`,
      loginData
    );
    return response;
  }

  async recoverPassword(loginData) {
    const response = await axios.post(
      `${this.base_url}/v1/auth/recover-password`,
      loginData
    );
    return response;
  }

  async ssoGoogle(idToken, source) {
    const response = await axios.post(
      `${this.base_url}/v1/auth/sso/google`,
      { id_token: idToken, source }
    );
    return response;
  }

  async ssoMicrosoft(idToken, source) {
    const response = await axios.post(
      `${this.base_url}/v1/auth/sso/microsoft`,
      { id_token: idToken, source }
    );
    return response;
  }

  async getlicenseList(token) {
    const response = await axios.get(`${this.base_url}/v1/license`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }

  async getPartner(token) {
    const response = await axios.get(
      `${this.base_url}/v1/auth/get-partner-data`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async getPartnerInfo(token) {
    const response = await axios.get(
      `${this.base_url}/v1/auth/get-partnerinfo-data`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async savePartner(token, partner) {
    const response = await axios.post(
      `${this.base_url}/v1/auth/save-partner-data`,
      partner,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async getServerVersion() {
    const response = await axios.get(`${this.base_url}/v1/version`);
    return response.data;
  }

  async ping() {
    const response = await axios.get(`${this.base_url}/ping`);
    return response.data;
  }

  async createVivawalletWebhook(token, vivapayload) {
    const response = await axios.post(
      `${this.base_url}/vivawallet-webhook-create`,
      vivapayload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  // Partner User Management
  async getPartnerUsers(token, page, perPage, filters, sort) {
    let query = `p=${page}&pp=${perPage}`;
    if (sort?.field) {
      query += `&sort_field=${sort.field}&sort_dir=${sort.dir || "asc"}`;
    }
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value) query += `&${key}=${value}`;
      });
    }
    const response = await axios.get(
      `${this.base_url}/v1/partner/users?${query}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async createPartnerUser(token, userData) {
    const response = await axios.post(
      `${this.base_url}/v1/partner/users`,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async updatePartnerUser(token, id, userData) {
    const response = await axios.put(
      `${this.base_url}/v1/partner/users/${id}`,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async deletePartnerUser(token, id) {
    const response = await axios.delete(
      `${this.base_url}/v1/partner/users/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async checkEmailExists(token, email) {
    const response = await axios.get(
      `${this.base_url}/v1/partner/users/check-email`,
      {
        params: { email },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async getVivaWalletWebhookStatus(token, partnerId) {
    const response = await axios.get(
      `${this.base_url}/vivawallet-webhook-status`,
      {
        params: {
          partner_id: partnerId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }
}
